/**
 * WHEN THE CALL BUTTON IS LIVE — ported from the mobile client's
 * `isTripCallableForMasking`, which is pure logic and worth copying rather than rewriting.
 *
 * ⚠️ BOTH CONDITIONS MUST HOLD: a driver has to be assigned, and the trip has to be in the
 * window where a call can be bridged. Outside it the backend has no driver leg to connect
 * to, so the button would fail on press rather than being honestly unavailable.
 */

/**
 * ⚠️ NORMALISED, BECAUSE THE BACKEND IS NOT CONSISTENT ABOUT CASING. "En Route", "en_route"
 * and "EnRoute" are all the same status and all appear in real responses. Lowercase and
 * strip spaces, underscores and hyphens, then compare.
 */
const normalise = (status) => String(status || '').toLowerCase().replace(/[\s_-]/g, '')

/**
 * ⚠️ `paymentholdfailed` IS CALLABLE, and that is deliberate rather than an oversight in
 * the list. A payment problem is exactly the moment a passenger may need to reach their
 * driver.
 */
const CALLABLE_STATUSES = [
    'accepted',
    'assigned',
    'enroute',
    'pendinghold',
    'paymentholdfailed',
    'inprogress',
]

export function isTripCallable(trip) {
    if (!trip) return false
    const hasDriver = Number(trip?.driver?.driver_id) > 0
    return hasDriver && CALLABLE_STATUSES.includes(normalise(trip?.status))
}

export default isTripCallable
